import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';
import LocaleTooling from '../../../tooling/localeTooling';

import Button from '../common/inputs/button';
import Select from '../common/inputs/select';
import SelectList from '../common/inputs/selectList';
import FetchAutocompleteList from '../common/inputs/fetchAutocompleteList';
import CheckBox from "../common/inputs/checkBox";
import BlueHeader from '../common/inputs/blueHeader';

const SupervisorsFilters = props => {
  const {
    onChangePeriod,
    periodsData,
    onChangeFilter,
    filterValues,
    modelsData,
    modelsLoading,
    modelsFetchAction,
    disabledPeriodSelector,
    loadingRevisionsGenerationButton, // boolean: Loading state of the generate revisions button.
    handleShowGenerateRevisionsConfirmPopup, // function: Standard function to show/hide a confirm popup. Called when pressing the generate revisions button.
    loadingSendMailsButton, // boolean: Loading state of the load metrics button.
    handleShowSendMailsConfirmPopup, // function: Standard function to show/hide a confirm popup. Called when pressing the send mails button.
  } = props;
  return (
    <div className="supervisors_admin_revisions_panel_filters_wrapper">
      <Select
        className="supervisors_admin_revisions_panel_filters_wrapper_period_selector"
        disabled={disabledPeriodSelector}
        value={filterValues["periodIdSelected"]}
        onChange={onChangePeriod}
        labelLocale={<FormattedMessage id="common.periodSelectLabel"/>}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(periodsData, "id", "name", false)}
      />   
      <BlueHeader
        labelLocale={<FormattedMessage id="supervisorsAdminRevisionPanel.generateRevisionsHeader"/>}
      />  
      <h3 className="filter_first_step filter_step_section">{<FormattedMessage id="supervisorsAdminRevisionPanel.modelsSelectionTitle"/>}</h3>
      <Select 
        value={filterValues["criteria"]}
        onChange={onChangeFilter}
        labelLocale={<FormattedMessage id="supervisorsAdminRevisionPanel.modelsFilterLabel"/>}
        options={InterfaceTooling.getSelectArray("selectKeys.supervisor.modelsFilters", "supervisorsAdminRevisionPanel.modelsFilter", false)}
        data-path="criteria"
      />
      {(filterValues["criteria"]!="" && (filterValues["criteria"]==Constants.selectKeys.supervisor.modelsFilters.ONLY || filterValues["criteria"]==Constants.selectKeys.supervisor.modelsFilters.ALL_EXCEPT)) && (
        <FetchAutocompleteList        
          values={filterValues["modelsSelected"]}
          onChange={onChangeFilter}
          addSelectLocale={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id:"supervisorsAdminRevisionPanel.modelsFilterFinderLabel"}))}
          options={InterfaceTooling.getSelectArrayFromArrayOfObjects(modelsData, "id", "name", false)}
          valueAccesor={"id"}
          labelAccesor={"name"}
          fetchListAction={modelsFetchAction}
          loadingFetch={modelsLoading}
          data-path="modelsSelected"
        />
      )}
      <h3 className="filter_step_section">{LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="supervisorsAdminRevisionPanel.generateRevisionsTitle"/>)}</h3>
      <Button
        disabled={loadingRevisionsGenerationButton}
        loading={loadingRevisionsGenerationButton}
        onClick={handleShowGenerateRevisionsConfirmPopup}
        labelLocale={<FormattedMessage id="supervisorsAdminRevisionPanel.generateRevisionButtonLabel"/>}
      />
      <React.Fragment>
        <h3 className="filter_step_section">{<FormattedMessage id="supervisorsAdminRevisionPanel.sendMailsTitle"/>}</h3>
        <Button
          disabled={loadingSendMailsButton}
          loading={loadingSendMailsButton}
          onClick={handleShowSendMailsConfirmPopup}
          labelLocale={<FormattedMessage id="supervisorsAdminRevisionPanel.sendMailsButtonLabel"/>}
        />
        <label className="form_info">
          <FormattedMessage id={"supervisorsAdminRevisionPanel.sendMailsHelp"} />
        </label>
      </React.Fragment>
    </div>
  );
};

export default SupervisorsFilters;



// WEBPACK FOOTER //
// ./source/client/components/supervisorsAdminRevisionPanel/filters.jsx